export enum FieldOrderType {
	Alphabetical,
	Manual
}